import { z } from "zod";

export type Domains = [string, ...string[]];
export const VINCI_DOMAINS: Domains = [
  "sdel.fr",
  "sitc.fr",
  "g-t.fr",
  "citeos.com",
  "cegelec.com",
  "vinci-energies.net",
  "vinci-energies.com",
  "omexom.com",
  "uxello-si.com",
  "axians.com",
  "actemium.com",
  "lucitea-atlantique.com",
] as const;
export const GRAFIT_DOMAINS: Domains = ["grafit.fr"] as const;

export const TENANTS = z.enum(["VINCI", "SHARED"]);
export type Tenant = z.infer<typeof TENANTS>;

export function domainToTenant(domain: string): Tenant {
  if (VINCI_DOMAINS.includes(domain)) {
    return TENANTS.enum.VINCI;
  }
  return TENANTS.enum.SHARED;
}
